<header class="header-helpdesk app-header navbar"
        [class.app-header-dev]="environmentFlavour === 'dev'"
        [class.app-header-demo]="environmentFlavour === 'demo'"
        [class.app-header-test]="environmentFlavour === 'test'">
  <button class="navbar-toggler mobile-sidebar-toggler hidden-lg-up" type="button"><i
    class="icomoon icomoon-menu-thick"></i></button>
  <!-- Logo / Brand -->
  <div class="navbar-brand" *ngIf="!brandLogoSrc"></div>
  <div class="navbar-asset-brand" *ngIf="brandLogoSrc">
    <img src="{{brandLogoSrc}}"/>
  </div>
  <ul class="nav navbar-nav hidden-md-down">
    <li class="nav-item">
      <a class="nav-link navbar-toggler sidebar-toggler" href="#" onclick="return false"><i
        class="icomoon icomoon-menu-thick"></i></a>
    </li>
  </ul>

  <span class="navbar-title">{{'COLONNADE_ONLINE_TITLE' | translate}}</span>

  <ul class="nav navbar-nav mx-2 ml-auto">
    <li class="nav-item cursor-pointer logout-btn" (click)="logout()">
      <i class="icomoon icomoon-logout mr-1"></i>
      <span>{{'MENU_NAVBAR_MENU_LOGOUT' | translate}}</span>
    </li>
  </ul>
</header>

<div class="sidebar">
  <div class="navbar-brand" id="navbar-brand" *ngIf="!brandLogoSrc || !brandLogoSmallSrc"></div>
  <div class="navbar-asset-brand" id="navbar-asset-brand" #brandLogoElement
     *ngIf="brandLogoSrc && brandLogoSmallSrc">
    <img *ngIf="!sidebarClosed" class="brand-logo-dimensions" src="{{brandLogoSrc}}"/>
    <img *ngIf="sidebarClosed" class="brand-logo-small-dimensions" src="{{brandLogoSmallSrc}}"/>
  </div>
  <nav class="sidebar-nav">
    <!-- region Sidebar list -->
    <ul class="nav">
      <app-sidebar-nav-item
        *ngFor="let item of navItems"
        [model]="item">
      </app-sidebar-nav-item>
    </ul>
    <!-- endregion -->
  </nav>
</div>

<div class="app-body">
  <main class="main">
    <div class="container-fluid">
      <ui-view></ui-view>
    </div>
  </main>
</div>

<span id="network-loader" *ngIf="networkLoading"></span>
<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
